import React, { useState } from "react";

import './LayoutStyles.scss';
import { Header } from "./Header";
import IdleTimer from 'react-idle-timer'
import { TimerDialog } from "../components/dialogs/TimerDialog";
import config from "../config";
import { strings } from "../strings/strings";
import { ProductType } from "../api/model/common";
import { ReminderPopup, EventTypeKey } from "../components/ReminderPopup";

interface MainLayoutProps {
    homeUrl: string
    children
    type: ProductType
}

export const MainLayout = (props: MainLayoutProps) => {
    const { homeUrl, children, type } = props
    const [isIdle, setIsIdle] = useState(false);

    const renderIdleTimer = () => {
        //@ts-ignore
        return <IdleTimer
            element={document}
            onIdle={() => setIsIdle(true)}
            debounce={250}
            timeout={config.idleTimeoutMillisecond} />;
    }

    const renderTimerDialog = () => {
        if (isIdle) {
            return <TimerDialog title={strings.areYouHere}
                initialTime={config.timeoutDialogMillisecond}
                open={isIdle}
                onClick={() => setIsIdle(false)}
                onTimeEnd={() => window.location.href = config.ARX_URL} />
        }
    }

    const eventTypeKey: Record<ProductType, EventTypeKey> = {
        [ProductType.EMTPL]: EventTypeKey.AVTOCIV,
        [ProductType.TRAVEL]: EventTypeKey.TRAVEL,
        [ProductType.GREEN_CARD]: EventTypeKey.GREEN_CARD,
    };
    
    const getEventTypeKey = (type: ProductType): EventTypeKey | null => {
        return eventTypeKey[type] || null;
    };

    const renderReminderPopup = () => {
        const eventTypeKey = getEventTypeKey(type);

        if (eventTypeKey) {
            return <ReminderPopup eventTypeKey={eventTypeKey} />;
        }
    };

    return (
        <div className={'wrapper'}>
            <Header homeUrl={homeUrl} type={type} />
            {renderIdleTimer()}
            {renderTimerDialog()}
            {renderReminderPopup()}

            <div className={'main-container'}>
                {children}
            </div>
        </div>
    )
};